import React from "react";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";

function NumericInput({
  id,
  name,
  defaultValue,
  onChange,
  placeholder,
  textAlign,
  className,
  leftAppend = null,
  rightAppend = null,
}) {
  const handleChange = (event) => {
    const { value: inputValue } = event.target;
    // Solo se permiten valores numéricos
    const numericValue = inputValue.replace(/[^\d.]/g, "");

    // Solo se permite un punto decimal
    const decimalCount = numericValue.split(".").length - 1;
    if (decimalCount > 1) return;

    // Actualizar el valor del input solo si es válido
    if (numericValue === "" || /^\d+(\.\d*)?$/.test(numericValue)) {
      event.target.value = numericValue;
      onChange(event);
    }
  };

  if (leftAppend || rightAppend)
    return (
      <div>
        <InputGroup>
          {leftAppend && (
            <InputGroupAddon addonType="prepend" style={{ height: 38 }}>
              <InputGroupText>{leftAppend}</InputGroupText>
            </InputGroupAddon>
          )}
          <Input
            type="text"
            id={id}
            name={name}
            defaultValue={defaultValue}
            onChange={handleChange}
            placeholder={placeholder}
            className={textAlign && `text-${textAlign} ${className}`}
            style={{ height: 38 }}
          />
          {rightAppend && (
            <InputGroupAddon addonType="append" style={{ height: 38 }}>
              <InputGroupText>{rightAppend}</InputGroupText>
            </InputGroupAddon>
          )}
        </InputGroup>
      </div>
    );

  return (
    <div>
      <Input
        type="text"
        id={id}
        name={name}
        defaultValue={defaultValue}
        onChange={handleChange}
        placeholder={placeholder}
        className={textAlign && `text-${textAlign} ${className}`}
      />
    </div>
  );
}

export default NumericInput;
